<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{ $t("centerlocation") }}</h4>
        </div>
      </div>
    </div>


    <!--content start-->
    <div id="location">
      <div class="grab">
        <div class="location_section">
          <img class="map_image" src="/static/img/location_map.jpg">
          <div class="map_content">
            <p><span class="glyphicon glyphicon-map-marker"></span>{{ $t("address") }}</p>
            <button class="location_btn" onclick="window.open('https://map.naver.com/?searchCoord=c4927209a697df8dc7bad2b0c7facd307b91ce8c485b460bdd423723b675e7b2&query=6rK96riw64%2BEIOyaqeyduOyLnCDsspjsnbjqtawg7Jm464yA66GcODEg7ZWc6rWt7Jm46rWt7Ja064yA7ZWZ6rWQIOyXsOq1rOyCsO2Vme2YkeugpeuLqCDrjIDquLDtmZjqsr3sl7DqtazshLzthLA%3D&tab=1&lng=aa7be9b7c04071ea87a08568d52fc710&mapMode=0&mpx=f7c9fea2c712eeeacba05143373cbc7622b0ab069d20930103bd0ffd7765461f8e619fc7343e8e75c58d468d816d6b7253289fa6d1c32c79ec90f4a5a989ae35&lat=1205ec84e6a95a5dc37145e12890b1cb&dlevel=10&enc=b64&menu=location')" tark>
              <span class="glyphicon glyphicon-map-marker"></span>{{ $t("naver_map") }}</button>
          </div>
        </div>
        <!--<img class="location_image" src="/static/img/location_map.jpg">-->
        <!--<p><span class="glyphicon glyphicon-map-marker"></span>{{ $t("address") }}</p>-->
        <!--<button class="location_btn" onclick="window.open('https://map.naver.com/?searchCoord=c4927209a697df8dc7bad2b0c7facd307b91ce8c485b460bdd423723b675e7b2&query=6rK96riw64%2BEIOyaqeyduOyLnCDsspjsnbjqtawg7Jm464yA66GcODEg7ZWc6rWt7Jm46rWt7Ja064yA7ZWZ6rWQIOyXsOq1rOyCsO2Vme2YkeugpeuLqCDrjIDquLDtmZjqsr3sl7DqtazshLzthLA%3D&tab=1&lng=aa7be9b7c04071ea87a08568d52fc710&mapMode=0&mpx=f7c9fea2c712eeeacba05143373cbc7622b0ab069d20930103bd0ffd7765461f8e619fc7343e8e75c58d468d816d6b7253289fa6d1c32c79ec90f4a5a989ae35&lat=1205ec84e6a95a5dc37145e12890b1cb&dlevel=10&enc=b64&menu=location')" tark>-->
          <!--<span class="glyphicon glyphicon-map-marker"></span>{{ $t("naver_map") }}</button>-->

      </div>
    </div>


  </div>
</template>
<script>
  export default {
    name: 'CenterLocation'
  }
</script>



// WEBPACK FOOTER //
// src/components/CenterLocation.vue